module.exports = __webpack_public_path__ + "img/env.6a07392.png";